export default __webpack_public_path__ + "static/media/EUL-Egypt.55a7edac.svg";